import { render } from "./AppSectionHeader.vue?vue&type=template&id=2784296c&scoped=true&ts=true&lang=pug"
import script from "./AppSectionHeader.vue?vue&type=script&lang=ts"
export * from "./AppSectionHeader.vue?vue&type=script&lang=ts"

import "./AppSectionHeader.vue?vue&type=style&index=0&id=2784296c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2784296c"]])

export default __exports__